/* eslint-disable @next/next/no-img-element */
import { logos_list } from '@/containers-ai/Logos';

//styles
import {
  LogosSection,
  CarouselWrapper,
  Label,
  LogosSlider,
  LogosList,
  Logo,
} from './Logos.styles';

export { logos_list };

function LogoMark({ item, lazy }) {
  return (
    <Logo>
      <img src={item.img} alt={item.alt} loading={lazy ? 'lazy' : undefined} />
    </Logo>
  );
}

// `label` is the (translated) title above the carousel; no label, no title.
export function Logos({ logos, label }) {
  const sliderspeed = logos.length * 4;

  return (
    <LogosSection>
      {label && <Label>{label}</Label>}
      <CarouselWrapper>
        <LogosSlider className="logoslider">
          <LogosList className="logoslider-list" items={sliderspeed}>
            {logos.map((item, key) => (
              <LogoMark key={key + '-a' + item.alt.trim()} item={item} />
            ))}
          </LogosList>
          <LogosList
            className="logoslider-list"
            items={sliderspeed}
            role="presentation"
          >
            {logos.map((item, key) => (
              <LogoMark key={key + '-b' + item.alt.trim()} item={item} lazy />
            ))}
          </LogosList>
          <LogosList
            className="logoslider-list"
            items={sliderspeed}
            role="presentation"
          >
            {logos.map((item, key) => (
              <LogoMark key={key + '-c' + item.alt.trim()} item={item} lazy />
            ))}
          </LogosList>
        </LogosSlider>
      </CarouselWrapper>
    </LogosSection>
  );
}
